// This file was once generated when you created this area
// but you can edit it freely

export const SIM_MANAGEMENT_BASE_ROUTE = '/sim-management'

export const SimManagementAreaRoutes = {
  route: SIM_MANAGEMENT_BASE_ROUTE,
  ComUnitDetails: {
    route: `${SIM_MANAGEMENT_BASE_ROUTE}/:eid`,
    path: ':eid',
  },
}
